import { __assign } from "tslib";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import { CommentEditorContext } from '../../../CommentEditor/context';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import s from './LazyPlaceholder.scss';
/**
 * What we'll show instead of the editor if the DaEditor chunk isn't loaded yet.
 *
 * It's a button that'll trigger the chunk to load.
 */
var LazyPlaceholder = function () {
    var t = useTranslation().t;
    var editorSource = useContext(CommentEditorContext).editorSource;
    var triggerProps = useContext(LoadableComponentContext).triggerProps;
    return (React.createElement(PlainButtonOrLink, __assign({ className: s['root'] }, triggerProps), editorSource === CommentEditorSource.Reply
        ? t('commentbox.editor.placeholder.reply')
        : t('commentbox.editor.placeholder')));
};
LazyPlaceholder.displayName = 'LazyPlaceholder';
export default LazyPlaceholder;
//# sourceMappingURL=LazyPlaceholder.js.map